// Whether an incoming CHANNEL message is "active" — already on-screen for the
// recipient — and so must NOT bold its channel in the sidebar or bump its unread
// count. Extracted from app.svelte.ts's notifyForIncoming so the decision is
// testable under the plain-node vitest env (app.svelte.ts can't be imported —
// Svelte runes), mirroring unread-reconcile.ts / cybo-dm-peer-id.ts.
//
// THE BUG: notifyForIncoming also treated a channel message as active when you
// were viewing the AUTHORING cybo's /agent page ("viewingThisAgent", commit
// 0dcc18306). But /agent/:id is a terminal/session host — it never renders the
// channel the cybo posted to. So a cybo posting to #X on your behalf while you
// sat on its /agent page (or its DM) left #X un-bolded even though you never
// opened #X: a message authored by someone else, in a channel you demonstrably
// had not viewed, silently marked seen. Read-state must follow "did you view
// THIS channel", NOT "are you looking at the author".
//
// THE FIX: a channel message is active only when the window is focused AND you
// are viewing that same channel in the same workspace. Who authored it, and
// whether you happen to be looking at that author's page, is irrelevant to
// whether the channel has unread content. (A mention still bumps the red count
// via the mention path; an agent's DM reply keeps its own "focused on the agent"
// suppression in handleIncomingAgentDm, which is correct — the DM route DOES
// render that conversation.)

export interface ChannelMessageActiveInput {
  /** document is visible and focused — windowFocused() at the call site. */
  windowFocused: boolean;
  /** conversationRendered() for this channel: on screen via its route, or via the Alerts pane. */
  conversationRendered: boolean;
  /** the incoming message's workspace id. */
  messageWorkspaceId: string | undefined;
  /** the workspace the user is currently in. */
  currentWorkspaceId: string | undefined;
}

export function channelMessageIsActive(input: ChannelMessageActiveInput): boolean {
  return (
    input.windowFocused &&
    input.conversationRendered &&
    input.messageWorkspaceId === input.currentWorkspaceId
  );
}
